import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("meta", {
  name: "google-signin-client_id",
  content: "GTM-WHCXM33"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("meta", {
  name: "google-signin-scope",
  content: "https://www.googleapis.com/auth/analytics.readonly"
}, null, -1)
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "アナリティクス")
], -1)
const _hoisted_5 = { class: "fw-bold fs-5 text-end" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " 毎日0時にデータが更新されます。過去30日以内のアクセス数が表示されます。期間内のアクセスが無い場合は、何も表示されません。 ", -1)
const _hoisted_7 = { class: "table table-hover table-bordered" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"min-width":"180px"}
    }, "ページタイトル"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ページURL"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"min-width":"60px"}
    }, "視聴回数"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"min-width":"60px"}
    }, "セッション")
  ])
], -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "4",
    class: "text-center"
  })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "d-grid d-md-flex justify-content-md-center" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("戻る")

import { ref, unref } from 'vue'
import { useMessenger } from '@/plugins/message'
import { useStore } from '@/store'
import draggable from 'vuedraggable'
import { useNicotto } from '@/plugins/nicotto'
import { onBeforeRouteLeave } from "vue-router";
import ButtonLink from "@/components/ui/ButtonLink.vue";
import {  } from 'aws-amplify'


export default /*#__PURE__*/_defineComponent({
  __name: 'AnalyticsView',
  setup(__props) {

const isDraggable = ref(false)
const nicotto = useNicotto()
const messenger = useMessenger()
const store = useStore()

const analytics = ref<any[]>([])

//公開URL取得用
const municipality = store.getters.isAdmin
  ? store.state.municipality
  : store.state.user?.municipality

if (municipality && municipality.status() === 'enabled' && municipality.path) {
  nicotto.concierge.getGoogleAnalyticsDataAPICount(municipality.path)
  .then(data => {
    analytics.value = data
  })
}

// 集計期間の計算 昨日の時点での30日間
const formatDate = (data: Date, joinChar: string) => {
  return data.getFullYear()+joinChar+(data.getMonth()+1)+joinChar+data.getDate()
}
const date1 = new Date()
const date2 = new Date()
const endDate = new Date(date1.setDate(date1.getDate()-1))
const endDateFormat = formatDate(endDate,"/")
const startDate = new Date(date2.setDate(date2.getDate()-30))
const startDateFormat = formatDate(startDate,"/")

// CSVエクスポート機能
const exportCsv = async() => {
  const linkUrl = window.URL.createObjectURL(await nicotto.concierge.getGoogleAnalyticsDataCsv(analytics.value))
  const link = document.createElement('a')
  link.href = linkUrl
  let linkTitle = 'access-count_'+formatDate(startDate,"-")+'-'+formatDate(endDate,"-")+'.csv'
  if (municipality && municipality.status() === 'enabled' && municipality.path) {
    linkTitle = municipality.path+'_'+linkTitle
  }
  link.download = linkTitle
  link.click()
  window.URL.revokeObjectURL(linkUrl)
}

onBeforeRouteLeave(() => {
  messenger.hide()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (_unref(municipality)?.status() === 'enabled')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("p", _hoisted_5, "集計期間：" + _toDisplayString(_unref(startDateFormat)) + "～" + _toDisplayString(_unref(endDateFormat)), 1),
            _hoisted_6
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", { class: "d-grid d-md-flex justify-content-md-end" }, [
        _createElementVNode("button", {
          class: "btn btn-primary mx-2 mb-2",
          onClick: exportCsv
        }, "エクスポート")
      ]),
      _createElementVNode("table", _hoisted_7, [
        _hoisted_8,
        (analytics.value.length>0)
          ? (_openBlock(), _createBlock(_unref(draggable), {
              key: 0,
              modelValue: analytics.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((analytics).value = $event)),
              "item-key": "id",
              tag: "tbody"
            }, {
              item: _withCtx(({ element }) => [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(element.page_title), 1),
                  _createElementVNode("td", null, _toDisplayString(element.page_path), 1),
                  _createElementVNode("td", null, _toDisplayString(element.screen_page_views), 1),
                  _createElementVNode("td", null, _toDisplayString(element.sessions), 1)
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_9, _hoisted_11))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(ButtonLink, {
          class: "btn-secondary mx-2 mb-2",
          to: "/",
          disabled: isDraggable.value
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ])
  ], 64))
}
}

})